import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspWarrantyCertificateDetailsService {

  constructor(private http: HttpClient) {}

getWarrantyDetails(orderKey: any,packageId: any ) {
  if (!orderKey) {
    console.error("Invalid orderKey for API call!");
    return;
  }
  // console.log("----- Get Warranty Details API Called -----");
  return this.http.get(
    `${GlobalVariable.BASE_API_URL_SPARES}/order/detail/${orderKey}/${packageId}`
  );
}


}
